import React from 'react';
import moment from 'moment';
import './BreakdownNav.css'

const BreakdownNav = ({ currentDay, currentMonth, currentYear, handlePreviousClick, handleNextClick, hasNext, hasPrevious }) => {
  const fmtDate = moment({
    year: currentYear,
    month: currentMonth-1,
    day: currentDay,
  }).format('LL');

  return (
    <div className="breakdown-nav">
    <div className="breakdown-nav__inner">
    <span className="btn btn-light" disabled={!hasPrevious} onClick={handlePreviousClick}>Previous Month</span>
    <span>
      <small>Current Month: </small>
      <span>{fmtDate}</span>
    </span>
    <span className="btn btn-light" disabled={!hasNext} onClick={handleNextClick}>Next Month</span>
  </div>
    </div>
  )
}

export default BreakdownNav;




// WEBPACK FOOTER //
// ./src/components/BreakdownNav/BreakdownNavv.js